import { useCallback, useEffect, useState } from "react";
import {
  Box,
  Container,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import {
  BoxText,
  Boxbackground,
  Boxconteiner,
  Boxdash,
  Boxfilearray,
  Boxinsite,
  Boxupload,
} from "./addRepairStyle";
import InputTextField from "../../../component/input/inputTextField";
import AutocompleteSelect from "../../../component/select/autoCompleteSelect";
import { useDropzone } from "react-dropzone";
import { useTranslation } from "react-i18next";
import DeleteIcon from "@mui/icons-material/Delete";
import ButtonCustom from "../../../component/button/buttonCustom";
import HeaderCard from "../../../component/cardCustom/headerCard";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Col, Row } from "react-bootstrap";
import ZoneApi from "../../../api/zone/zone.api";
import { notiError, notiSuccess } from "../../../component/notification/notifications";
import RepairTypeApi from "../../../api/setting/repair/repairType.api";
import RepairApi, { createRepairInterface } from "../../../api/repair/repair.api";
import { colors } from "../../../constants/colors";
import { getBranch, getProfile } from "../../../utils/app.utils";
import { decode } from "js-base64";
import moment from "moment";
import FileuploadApi from "../../../api/uploadfile/upload.api";
import { getApiErrorMessage } from "../../../utils/api-error.utils";
import Loading from "../../../component/loading/loading";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import HelperText from "../../../component/input/helperText";
import { useHistory, useLocation } from "react-router-dom";
import { stallLabel } from "../../../utils/stall.utils";
type errorMessageType = {
  repairTypeId: string;
  zoneCheck: string;
  centralDescription: string;
  description: string;
}
const initialErrorMessage = {
  repairTypeId: '',
  zoneCheck: '',
  centralDescription: '',
  description: ''
}

export default function AddRepair() {
  const { t } = useTranslation();
  const profile: any = JSON.parse(getProfile() || "{}");
  const branchId: any = getBranch() ? Number(getBranch()) : undefined
  const history = useHistory();
  const location: any = useLocation();
  const userId = new URLSearchParams(location.search).get("userId");
  const redirectPath: string = userId && !isNaN(Number(userId)) ? `/repair-by-agent/${userId}` : "/repair";

  const [file, setFile] = useState<any>([]);
  const [select, setSelectfile] = useState<any>();
  const [zone, setZone] = useState<any>([]);
  const [stall, setStall] = useState<any>([]);
  const [description, setDescription] = useState<string>()
  const [zoneId, setZoneId] = useState<any>("")
  const [stallId, setStallId] = useState<any>("")
  const [centralCheck, setCentralCheck] = useState<boolean>(false)
  const [zoneCheck, setZoneCheck] = useState<boolean>(false)
  const [centralDescription, setCentralDescription] = useState<string>()
  const [repairTypeData, setRepairTypeData] = useState<any[]>([])
  const [repairTypeId, setRepairTypeId] = useState<number>()
  const [leaseAgreementId, setLeaseAgreementId] = useState<number>()
  const [contactPhones, setContactPhones] = useState<string[]>([""])
  const [isLoading, setIsLoading] = useState<boolean>(false);


  const [errorMessage, setErrorMessage] = useState<errorMessageType>(initialErrorMessage)

  const clearErrorMessage = () => setErrorMessage(initialErrorMessage)

  const getZone = async () => {
    const condition = {
      page: 1,
      pageLimit: 100,
      status: "CONTRACT",
      skipcalculation: 0,
      branchId:branchId
    };
    await ZoneApi.findAll(condition).then((res) => {
      if (res.status === 200) {
        setZone(res?.data);
      }
    });
  };

  useEffect(() => {
    getZone();
  }, []);

  const loadRepairTypeData = useCallback(async () => {
    let condition: any = {
      page: 1,
      pageLimit: 10
    }

    await RepairTypeApi.findAll(condition)
      .then((res: any) => {
        if (res.status === 200) {
          setRepairTypeData(res?.data)
        } else {
          setRepairTypeData([])
        }
      })
  }, [])

  useEffect(() => {
    loadRepairTypeData()
  }, [])

  const onDrop = useCallback(
    (acceptedFiles) => {
      const files = acceptedFiles[0];

      const fileName = files?.name.split(".");
      const detailImage = {
        base64: "",
        filePath: files?.path,
        fileName: files?.name,
        ext: fileName[fileName?.length - 1],
      };
      if (
        detailImage.ext === "png" ||
        detailImage.ext === "jpg" ||
        detailImage.ext === "pdf"
      ) {
        setFile([...file, acceptedFiles[0]]);
      } else {
        notiError(`${t("ANNOUNCE.NOTI.ERROR")}`, "", null, null);
      }
    },
    [file]
  );

  const { getRootProps, getInputProps } = useDropzone({ onDrop, accept: { 'image/*': [] }, onDropRejected: (reject) => console.log(reject) });
  const handlepreview = (x: any) => {
    const name = x.type.split(".");

    if (name[name?.length - 1] === "application/pdf") {

      window.open(URL.createObjectURL(x), "_blank");
    } else {
      setSelectfile(URL.createObjectURL(x));
    }
  };
  const handledelete = (x: any) => {
    setFile(file.filter((y: any) => y.path !== x.path));
    setSelectfile(null);
  };

  /** รับเฉพาะตัวเลข สูงสุด 10 หลัก — maxLength ของ input ใช้ไม่ได้ถ้าเป็น type="number" จึงกรองที่นี่ */
  const handleChangeContactPhone = (index: number, value: string) => {
    const digits = String(value).replace(/\D/g, "").slice(0, 10)
    setContactPhones((prev) => prev.map((phone, i) => (i === index ? digits : phone)))
  }
  const handleAddContactPhone = () => setContactPhones((prev) => ([...prev, ""]))
  const handleDeleteContactPhone = (index: number) => {
    setContactPhones((prev) => {
      const next = prev.filter((_, i) => i !== index)
      // คงช่องว่างไว้ 1 ช่องเสมอ ไม่ให้แถวหายไปทั้งหมด
      return next.length ? next : [""]
    })
  }

  const validateForm = (): boolean => {
    let validateCheck: boolean = false;
    if (!repairTypeId) {
      setErrorMessage((prev) => ({ ...prev, repairTypeId: 'ระบุประเภทงาน' }))
      return validateCheck = true
    }
    if (!zoneCheck && !centralCheck) {
      notiError("กรุณาเลือก")
      return validateCheck = true
    }
    if (zoneCheck && (!zoneId || !stallId)) {
      setErrorMessage((prev) => ({ ...prev, zoneCheck: 'ระบุโซน/แผง' }))
      return validateCheck = true
    }
    if (centralCheck && !centralDescription) {
      setErrorMessage((prev) => ({ ...prev, centralDescription: 'ระบุ' }))
      return validateCheck = true
    }
    if (centralCheck && !centralDescription) {
      setErrorMessage((prev) => ({ ...prev, centralDescription: 'ระบุส่วนกลาง' }))
      return validateCheck = true
    }
    if (!description) {
      setErrorMessage((prev) => ({ ...prev, description: 'ระบุเรื่องที่แจ้ง' }))
      return validateCheck = true
    }
    return validateCheck
  }

  const createRepair = async () => {
    const validateData: boolean = validateForm();
    let condition: createRepairInterface = {
      branchId: branchId,
      repairDate: String(moment(Date.now()).format("YYYY-MM-DD")),
      repairTypeId: Number(repairTypeId),
      title: "แจ้งซ่อม",
      description: String(description),
      zoneCheck: String(zoneCheck).toLocaleUpperCase(),
      leaseAgreementId: leaseAgreementId || null,
      zoneId: null,
      stallId: null,
      centralCheck: String(centralCheck).toLocaleUpperCase(),
      centralDescription: centralDescription,
      contactPhones: contactPhones.map((phone) => phone.trim()).filter(Boolean)
    }

    if (zoneId) condition = { ...condition, zoneId: Number(zoneId), }
    if (stallId) condition = { ...condition, stallId: Number(stallId.stallId), }

    if (validateData) {
      return;
    } else {
      setIsLoading(true)
      const res = await RepairApi.create(condition)
      if (res.status === 201) {
        const uploadDocument = new FormData();
        uploadDocument.append("refId", `${res.data.refId}`);
        uploadDocument.append("fileType", "repair");
        file
          .filter((data: any) => data instanceof File)
          .forEach((data: File) => {
            uploadDocument.append(`files[]`, data);
          });

        // เดิมไม่มี try/catch — upload endpoint ตอบ 500 จริงแล้ว ถ้าพัง setIsLoading(false)
        // จะไม่ถูกเรียกเลย spinner ค้างถาวร ผู้ใช้ต้อง reload หน้า
        try {
          await FileuploadApi.uploadfilearray(uploadDocument)
          notiSuccess("แจ้งซ่อมสำเร็จ", "", "", () => {
            history.push(redirectPath)
          })
        } catch (error) {
          // ใบแจ้งซ่อมถูกสร้างแล้ว ห้ามบอกว่า "ไม่สำเร็จ" ผู้ใช้จะกดซ้ำแล้วได้ใบซ้ำ
          notiError(
            getApiErrorMessage(error, "แจ้งซ่อมสำเร็จ แต่แนบไฟล์ไม่สำเร็จ กรุณาแนบไฟล์ใหม่อีกครั้ง"),
            "",
            "",
            () => {
              history.push(redirectPath)
            }
          )
        } finally {
          setIsLoading(false)
        }
      }
      else {
        setIsLoading(false)
        notiError("แจ้งซ่อมไม่สำเร็จ")
      }
    }

  }

  return (
    <Box sx={{ position: "relative" }}>
      {isLoading && <Loading show />}
      <HeaderCard text={t("ADDREPAIR.HEADER.HEADTOP")} />
      <Container maxWidth="xl">
        <Boxinsite>
          <Boxbackground>
            <Boxconteiner>
              <Row>
                <Col className="my-2" md={1} xs={12} style={{ whiteSpace: 'nowrap' }}>
                  {t("ADDREPAIR.DETAIL.TYPE")} <span style={{ color: colors.red }}>*</span> :
                </Col>
                <Col item md={11} xs={12} className="my-2">
                  <AutocompleteSelect
                    placeholder={t("ADDREPAIR.PLACEHOLDER.TYPE")}
                    helperText={errorMessage.repairTypeId}
                    options={repairTypeData}
                    value={repairTypeData && repairTypeData.find((e: any) => e.repairTypeId === repairTypeId)}
                    onChange={(e: any, val: any) => {
                      clearErrorMessage();
                      setRepairTypeId(val?.repairTypeId)
                    }}
                    getOptionLabel={(option: any) => option?.repairTypeName}
                    labelId="add"
                  />
                </Col>
                <Col className="my-2" md={1} sm={12} xs={12}>
                  <label>
                    <input type="radio" name="myRadio" checked={zoneCheck} value="option1" className="mr-2" onChange={() => {
                      setZoneCheck(true)
                      setCentralCheck(false)
                      setCentralDescription("")
                    }} />
                    {t("ADDREPAIR.DETAIL.ZONE")} :
                  </label>
                  {/* <InputCheckbox disabled={centralCheck} checked={zoneCheck}  onChange={(e) =>setZoneCheck(e.target.checked)} label={t("ADDREPAIR.DETAIL.ZONE")} /> */}
                </Col>
                <Col className="my-2" md={5} xs={12}>
                  <AutocompleteSelect
                    placeholder={t("ADDREPAIR.PLACEHOLDER.ZONE")}
                    options={zone}
                    value={zone?.find((e: any) => e.zoneId === zoneId) || null}
                    labelId="add"
                    getOptionLabel={(option: any) => option.zoneName}
                    onChange={(event, newValue) => {
                      setZoneCheck(true)
                      setZoneId(newValue?.zoneId)
                      setStall(newValue?.stall);
                      setStallId('');
                      setLeaseAgreementId(undefined)
                      clearErrorMessage()
                    }}
                    disabled={centralCheck}
                  />
                </Col>
                <Col className="my-2" md={1} xs={12}>
                  {t("ADDREPAIR.DETAIL.STALL")} :
                </Col>
                <Col className="my-2" md={5} xs={12}>
                  <AutocompleteSelect
                    placeholder={t("ADDREPAIR.PLACEHOLDER.STALL")}
                    options={stall}
                    getOptionLabel={(option: any) => stallLabel(option)}
                    value={stallId || null}
                    disabled={centralCheck}
                    labelId="add"
                    onChange={(event, newValue) => {
                      setStallId(newValue)
                      setLeaseAgreementId(newValue?.leaseAgreementId)
                      clearErrorMessage()
                    }}
                  />
                </Col>
                {errorMessage?.zoneCheck && <><Col xs={1}></Col><Col xs={11}><HelperText label={errorMessage?.zoneCheck || ''} /></Col></>}
                {JSON.parse(decode(profile))?.roleId !== 4 &&
                  <><Col className="my-2" lg={1} xs={12}>
                    <label style={{ whiteSpace: 'nowrap' }}>
                      <input type="radio" name="myRadio" value="option1" className="mr-2" onChange={(e) => {
                        setZoneCheck(false)
                        setCentralCheck(true)
                        setStall([])
                        setStallId("")
                        setZoneId("")
                      }} />
                      {t("ADDREPAIR.DETAIL.CENTRAL")} :
                    </label>
                    {/* <InputCheckbox checked={centralCheck} disabled={zoneCheck} onChange={(e) => setCentralCheck(e.target.checked)} label={t("ADDREPAIR.DETAIL.CENTRAL")} /> */}
                  </Col>
                    <Col className="my-2" md={11} xs={12}>
                      <InputTextField disabled={zoneCheck} placeholder={t("ADDREPAIR.PLACEHOLDER.CENTRAL")} value={centralDescription} onchange={(e) => {
                        setCentralDescription(e.target.value)
                        clearErrorMessage()
                      }} helperText={errorMessage.centralDescription}
                      />
                    </Col></>}
                <Col className="my-2" md={1} xs={12} style={{ whiteSpace: 'nowrap' }}>
                  {t("ADDREPAIR.DETAIL.CONTENT")} <span style={{ color: colors.red }}>*</span> :
                </Col>
                <Col className="my-2" md={11} xs={12}>
                  <InputTextField value={description} placeholder={t("ADDREPAIR.PLACEHOLDER.CONTENT")} onchange={(e) => {
                    setDescription(e.target.value)
                    clearErrorMessage()
                  }} helperText={errorMessage.description} />
                </Col>
                <Col className="my-2" md={1} xs={12} style={{ whiteSpace: 'nowrap' }}>
                  {t("ADDREPAIR.DETAIL.CONTACT_PHONE")} :
                </Col>
                <Col className="my-2" md={11} xs={12}>
                  {contactPhones?.map((phone: string, index: number) => (
                    <Box key={`contact-phone-${index}`} sx={{ display: 'flex', alignItems: 'center', mb: '8px' }}>
                      <Box sx={{ flex: 1 }}>
                        <InputTextField
                          value={phone}
                          placeholder={t("ADDREPAIR.PLACEHOLDER.CONTACT_PHONE")}
                          inputProps={{ maxLength: 10 }}
                          onchange={(e: any) => handleChangeContactPhone(index, e.target.value)}
                        />
                      </Box>
                      <IconButton onClick={() => handleDeleteContactPhone(index)} sx={{ ml: '8px' }}>
                        <DeleteIcon color="error" />
                      </IconButton>
                    </Box>
                  ))}
                  <ButtonCustom
                    mode="add"
                    variant="outlined"
                    onClick={handleAddContactPhone}
                    textButton={t("ADDREPAIR.BUTTON.ADD_CONTACT_PHONE")}
                  />
                </Col>
                <Col item lg={1} xs={12}>
                  {t("ADDREPAIR.DETAIL.ATTACH_FILE")}
                </Col>
                <Col className="my-2" item md={11} xs={12}>
                  <Boxupload style={{ position: "relative" }}>
                    {" "}
                    <Boxdash>
                      <div {...getRootProps()}>
                        <input {...getInputProps()} />

                        {select ? (
                          <>
                            {/* <IconButton sx={{ position: 'absolute', top:"10px", right:"10px" }} onClick={() => setSelectfile(null)}><HighlightOffIcon /></IconButton> */}
                            <img src={select} alt="Thumb" height="300px" style={{ cursor: 'pointer' }} />
                          </>
                        ) : (

                          <Box
                            sx={{
                              flexDirection: "column",
                              display: "flex",
                              alignItems: "center",
                              cursor: 'pointer'
                            }}
                          >
                            <AddPhotoAlternateIcon style={{ fontSize: 60 }} />
                            <BoxText>
                              <Typography
                                sx={{
                                  marginTop: "24px",
                                  fontSize: "18px",
                                  fontFamily: "kanit",
                                }}
                              >
                                แนบไฟล์รูปภาพ JPG, PNG
                              </Typography>
                            </BoxText>
                          </Box>

                        )}
                      </div>
                    </Boxdash>
                  </Boxupload>
                </Col>

                {file?.map((x: any, index: any) => (
                  <>
                    <Col md={1} xs={12}></Col>
                    <Col md={1} xs={12} className="my-2 d-flex justify-content-end align-items-center">
                      ลำดับที่ {index + 1}
                    </Col>
                    <Col item md={10} xs={12} className="my-2">
                      <Boxfilearray>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Box>{x.name}</Box>

                          <Box>
                            <VisibilityIcon
                              onClick={() => handlepreview(x)}
                              sx={{ cursor: "pointer", marginRight: "10px" }}
                            />
                            <DeleteIcon
                              onClick={() => handledelete(x)}
                              color="error"
                              sx={{ cursor: "pointer" }}
                            />
                          </Box>
                        </Box>
                      </Boxfilearray>
                    </Col>
                  </>
                ))}

                <Grid item lg={12} xs={12}>
                  <ButtonCustom
                    disabled={isLoading}
                    onClick={createRepair}
                    textButton={t("REGISTER.BUTTON.SUMMIT")}
                    btnStyle={{
                      fontSize: "16px",
                      width: "100%",
                      padding: "0px",
                      marginTop: "32px",
                      marginBottom: "14px",
                    }}
                  />
                </Grid>
              </Row>
            </Boxconteiner>
          </Boxbackground>
        </Boxinsite>
      </Container>
    </Box>
  );
}
